var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.167,
    height: 15.167,
    viewBox: "0 0 15.167 15.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #009ab2;\n      }\n\n      .cls-3, .cls-5 {\n        stroke: none;\n      }\n\n      .cls-5 {\n        fill: #009ab2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(-337.5 -113.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share_Icon",
    "data-name": "Share Icon",
    transform: "translate(337.5 113.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-1",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-1",
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-2",
    transform: "translate(10.111 10.111)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.528,0A2.528,2.528,0,1,1,0,2.528,2.528,2.528,0,0,1,2.528,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M 2.52777099609375 1.000000953674316 C 1.685350894927979 1.000000953674316 1.000000953674316 1.685350894927979 1.000000953674316 2.52777099609375 C 1.000000953674316 3.370191097259521 1.685350894927979 4.055541038513184 2.52777099609375 4.055541038513184 C 3.370191097259521 4.055541038513184 4.055541038513184 3.370191097259521 4.055541038513184 2.52777099609375 C 4.055541038513184 1.685350894927979 3.370191097259521 1.000000953674316 2.52777099609375 1.000000953674316 M 2.52777099609375 9.5367431640625e-07 C 3.923820972442627 9.5367431640625e-07 5.055541038513184 1.131721019744873 5.055541038513184 2.52777099609375 C 5.055541038513184 3.923820972442627 3.923820972442627 5.055541038513184 2.52777099609375 5.055541038513184 C 1.131721019744873 5.055541038513184 9.5367431640625e-07 3.923820972442627 9.5367431640625e-07 2.52777099609375 C 9.5367431640625e-07 1.131721019744873 1.131721019744873 9.5367431640625e-07 2.52777099609375 9.5367431640625e-07 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-1",
    d: "M0,3.138,6.8,0",
    transform: "translate(3.922 3.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-1",
    d: "M6.8,3.138,0,0",
    transform: "translate(3.922 8.629)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.126531d9ae17259ac9f70bd0eb2ab03a.svg";
export { ForwardRef as ReactComponent };